import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "ml-1 text-red-500"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "?", -1)
const _hoisted_4 = { class: "flex justify-between items-center mb-6" }
const _hoisted_5 = ["value", "name", "multiple"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  selected: "",
  disabled: ""
}, " Please select ", -1)
const _hoisted_7 = ["value", "onClick"]
const _hoisted_8 = {
  key: 1,
  class: "block mb-2 -mt-4 text-red-500 text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "relative flex items-center w-full mb-2",
          for: _ctx.name
        }, [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
            (_ctx.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, " * "))
              : _createCommentVNode("", true)
          ]),
          (_ctx.amplification)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "bg-gray-700 ml-2 text-white w-5 h-5 text-sm p-2 rounded-full inline-flex items-center justify-center cursor-pointer",
                onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAmplification=true)),
                onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAmplification=false))
              }, [
                _hoisted_3,
                (_ctx.amplification && _ctx.showAmplification)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "absolute top-full mt-2 left-0 z-50 block w-full mb-6 rounded text-sm bg-gray-700 p-3 text-white",
                      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAmplification=true)),
                      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAmplification=false))
                    }, _toDisplayString(_ctx.amplification), 33))
                  : _createCommentVNode("", true)
              ], 32))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("select", {
        placeholder: "Please select",
        class: _normalizeClass(["block w-full px-4 py-2 rounded border border-gray-300 shadow-sm cursor-pointer focus:ring-brand", [_ctx.readonly ? 'bg-gray-100' : '', _ctx.error ? 'border-red-500' : '']]),
        value: _ctx.selected,
        name: _ctx.name,
        multiple: _ctx.multiple,
        onInput: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$emit('update:modelValue', $event.target.value); _ctx.$emit('input', $event)}),
        onChange: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$emit('update:modelValue', $event.target.value); _ctx.$emit('change', $event)}),
        onBlur: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$emit('update:modelValue', $event.target.value); _ctx.$emit('blur', $event)})
      }, [
        _hoisted_6,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: option.value,
            value: option.value,
            onClick: ($event: any) => (_ctx.selected = option.value)
          }, _toDisplayString(option.title), 9, _hoisted_7))
        }), 128))
      ], 42, _hoisted_5),
      (_ctx.contactadd)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "ml-4 min-w-max h-10 justify-center px-4 border border-green-500 shadow-sm text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-600 hover:border-green-600",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.contactAdd && _ctx.contactAdd(...args)))
          }, " Add Contact "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 64))
}